// Why do we default to spend? Shouldn't we default to a warning?

export default class OfferTypeHelperService {
  // To prevent the reuse of the same code that WILL have more options added
  // TODO: Deprecate this. Just get the display name off the API
  // If it's not coming back somewhere, it needs to be added
  /*
   * @deprecated
   * */
  humanReadableOfferType(offerType) {
    switch (offerType) {
      case 'UNIT_MARKET_SHARE':
        return 'Unit Market Share';
      case 'DOLLAR_MARKET_SHARE':
        return 'Spend Market Share';
      case 'ABSOLUTE_UNITS':
        return 'Unit Volume';
      case 'ABSOLUTE_DOLLARS':
        return 'Spend Volume';
    }

    console.warn(
      'Warning: ' +
        offerType +
        ' is not a valid value in humanReadableOfferType.'
    );
  }

  /*
   * @deprecated
   * */
  humanReadableOfferTypeShort(offerType) {
    switch (offerType) {
      case 'ABSOLUTE_UNITS':
      case 'UNIT_MARKET_SHARE':
        return 'Unit';
      case 'ABSOLUTE_DOLLARS':
      case 'DOLLAR_MARKET_SHARE':
        return 'Spend';
    }

    console.warn(
      'Warning: ' +
        offerType +
        ' is not a valid value in humanReadableOfferTypeShort.'
    );
  }

  // TODO: Get rid of this switch. Get this value off the API
  /*
   * @deprecated
   * */
  switchTypes(typeName) {
    switch (typeName) {
      case 'UNIT_MARKET_SHARE':
        return 'unitMarketShare';
      case 'DOLLAR_MARKET_SHARE':
        return 'dollarMarketShare';
      case 'ABSOLUTE_UNITS':
        return 'absoluteUnits';
      case 'ABSOLUTE_DOLLARS':
        return 'absoluteSpend';
    }

    console.warn(
      'Warning: ' + typeName + ' is not a valid value in switchTypes.'
    );
  }

  /*
   * @deprecated
   * */
  getAllocatedMarketShare(plannedSpendLevel: any) {
    if (!plannedSpendLevel || !plannedSpendLevel.type) {
      return;
    }

    return this.getValueFromType(
      plannedSpendLevel.type.name,
      plannedSpendLevel
    );
  }

  /*
   * @deprecated
   * */
  getIncumbentPlannedSpendLevel(incumbentPlannedSpendLevel: any) {
    if (!incumbentPlannedSpendLevel || !incumbentPlannedSpendLevel.type) {
      return;
    }

    return this.getValueFromType(
      incumbentPlannedSpendLevel.type.name,
      incumbentPlannedSpendLevel
    );
  }

  /*
   * @deprecated
   * */
  getSpendLevelType(spendLevelType: any) {
    if (!spendLevelType || !spendLevelType.type) {
      return;
    }

    return this.getValueFromType(spendLevelType.type.name, spendLevelType);
  }

  // NOTE: We shouldn't use this. Use spendLevelType.fieldNames instead
  /*
   * @deprecated
   * */
  getValueFromType(type, levels) {
    if (!levels || !type) {
      return;
    }

    switch (type) {
      case 'UNIT_MARKET_SHARE':
        return levels.unitMarketShare;
      case 'DOLLAR_MARKET_SHARE':
        return levels.dollarMarketShare;
      case 'ABSOLUTE_UNITS':
        return levels.absoluteUnits;
      case 'ABSOLUTE_DOLLARS':
        return levels.absoluteDollars;
    }

    console.warn(
      'Warning: ' + type + ' is not a valid value in getValueFromType.'
    );
  }
}
